<div class="app-shell" [class.app-shell--sidebar-collapsed]="sidebarCollapsed()" [class.app-shell--mobile-sidebar-open]="mobileSidebarOpen()">
      <!-- Mobile Sidebar Overlay -->
      <div class="mobile-sidebar-overlay" (click)="closeMobileSidebar()"></div>

      <!-- Sidebar -->
      <ams-sidebar
        [items]="filteredNavItems()"
        [logo]="logoUrl()"
        [logoIcon]="'/ams-icon.png'"
        [logoAlt]="logoAlt()"
        [brandBadge]="chapterBadge()"
        [initialCollapsed]="sidebarCollapsed()"
        (collapsedChange)="onSidebarCollapse($event)"
      >
      </ams-sidebar>

      <!-- Main Content Area -->
      <div class="app-main">
        <!-- Header -->
        <header class="app-header">
          <div class="app-header__left">
            <!-- Mobile Menu Button -->
            <button class="mobile-menu-btn" (click)="toggleMobileSidebar()" title="Toggle menu">
              <fa-icon [icon]="iconService.getIcon('menu')" size="lg" />
            </button>
            @if (portalMode()) {
              <!-- Organization Name (Portal) -->
              <span class="portal-org-name">{{ orgName() }}</span>
            } @else {
              <app-global-search />
            }

            <!--
              Billing-degraded notice. Sits outside the portalMode branch above so
              it shows in both states — it is a condition of the tenant, not of the
              search bar it happens to sit next to.
            -->
            <!--
              Suppressed for the platform tenant: Membora staff administer other
              associations and have no plan of their own, so "your plan limits are
              from a snapshot" describes nothing they own. The signal itself stays
              accurate — only this audience is wrong for it.
            -->
            @if (planEntitlements.isDegraded() && !isPlatformTenant()) {
              <ams-banner
                variant="warning"
                [message]="planEntitlements.degradedMessage()"
              />
            }

            <!--
              Invoice-outstanding notice for the association's own subscription.
              Two states, two tones — see PLAN_PAYMENT_MESSAGES.

              Suppressed in portalMode: that audience can't settle the association's
              invoice, so a dunning notice is someone else's business to them. The
              degraded banner above deliberately DOES show in both — it explains why a
              figure on screen might be stale, which is relevant to anyone reading it.

              Also suppressed while degraded, by construction rather than by an extra
              condition here: the API nulls the payment fields whenever it is serving a
              snapshot, so a stale "you owe money" cannot reach this banner.
            -->
            @if (planEntitlements.hasPaymentNotice() && !isPlatformTenant() && !portalMode()) {
              <ams-banner
                [variant]="planEntitlements.paymentNoticeVariant()"
                [message]="planEntitlements.paymentNoticeMessage()"
              />
              <!--
                Pay without a detour through /my-account. A sibling of the banner
                rather than a slot inside it — ams-banner takes only variant/message,
                and giving it an action slot would change every other screen that
                uses it.

                Gated on billing MANAGE while the banner itself is not: the notice is
                worth seeing either way, but the endpoints behind this button require
                tenant.billing, so for a read-only admin it could only 403. They see
                the banner and no button, which is the honest pairing.
              -->
              @if (accessControl.hasAccess('tenant.billing', 'manage')) {
                <ams-button
                  variant="secondary"
                  size="sm"
                  [loading]="invoicePayment.isBusy(invoicePaymentBannerKey)"
                  (clicked)="invoicePayment.openForCurrentTenant(invoicePaymentBannerKey)"
                >
                  Pay now
                </ams-button>
              }
            }
          </div>

          <div class="app-header__right">
            @if (!portalMode()) {
              <!-- AI Chat (admin shell only — member portal is out of scope for v1) -->
              <button class="ai-chip" type="button" (click)="toggleChatbot()" title="Membora AI" aria-label="Membora AI">
                <fa-icon [icon]="iconService.getIcon('membora-ai')" />
              </button>
            }

            <!-- Notifications -->
            <app-notification-bell #bellRef />

            <!-- User Menu -->
            <ams-divider orientation="vertical"></ams-divider>
            <div (mousedown)="bellRef.close()">
            <ams-dropdown-menu [items]="userMenuItems()" (itemClick)="onUserMenuAction($event)">
              <button class="user-menu" type="button" title="User menu">
                <ams-avatar
                  [name]="currentUserName()"
                  [src]="authService.currentUser()?.avatarUrl || ''"
                  size="sm"
                />
                <div class="user-menu__info">
                  <span class="user-menu__name">{{ currentUserName() }}</span>
                  @if (activeOrgName()) {
                    <span class="user-menu__org">{{ activeOrgName() }}</span>
                  }
                  <span class="user-menu__role">{{ userRoleLabel() }}</span>
                </div>
                <fa-icon [icon]="iconService.getIcon('chevron-down')" size="xs" />
              </button>
            </ams-dropdown-menu>
            </div>
          </div>
        </header>

        <!-- Page Content -->
        <main class="app-content">
          <app-pending-membership-banner />
          <router-outlet />
        </main>

        <!-- Global Footer -->
        <ams-footer></ams-footer>
        
      </div>

      <!-- AI Copilot Panel (placeholder, hidden in portal mode) -->
      @if (copilotOpen() && !portalMode()) {
        <div class="copilot-panel">
          <div class="copilot-header">
            <h3>AI Copilot</h3>
            <button class="icon-btn" (click)="toggleCopilot()">
              <fa-icon [icon]="iconService.getIcon('close')" />
            </button>
          </div>
          <div class="copilot-body">
            <p class="copilot-placeholder">AI Copilot panel will be implemented here.</p>
          </div>
        </div>
      }
      <!-- Membora AI chatbot panel — mounted once, opened via the AI button -->
      @if (!portalMode()) {
        <app-chatbot-panel />
      }

      <ams-toast-container position="top-right" />
    </div>
